import React, {ReactNode} from 'react';
import classNames from 'classnames';

type ContainerProps = {
  currentPathname?: string;
  children: ReactNode;
};

const isBlogpost = (pathname: string) => pathname.includes('/post/');

export const Container: React.FC<ContainerProps> = props => (
  <div className={classNames({'overflow-x-hidden': !isBlogpost(props.currentPathname)})}>{props.children}</div>
);
